export const UMB_MEDIA_ITEM_REPOSITORY_ALIAS = 'Umb.Repository.MediaItem';
export const UMB_MEDIA_STORE_ALIAS = 'Umb.Store.MediaItem';
export { UMB_MEDIA_ITEM_STORE_CONTEXT } from './media-item.store.context-token.js';
